export const DD_MM_YYYY_WITH_SLASH_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;
export const YYYY_MM_DD_WITH_DASH_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const VALID_EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
